<template>
  <div class="page-index page-background-image">
    <div class="page-lantern-img">
      <div class="lantern-img"></div>
    </div>
    <index-head/>
    <index-title-img/>
    <index-bottle-img/>
    <wish-action/>
    <right-action/>
    <task/>
  </div>
</template>

<script>
import IndexHead from "@/views/lotto/components/Head";
import IndexTitleImg from "@/views/lotto/components/Title";
import IndexBottleImg from "@/views/lotto/components/Bottle";
import WishAction from "@/views/lotto/components/WishAction";
import RightAction from "@/views/lotto/components/RightAction";
import Task from "@/views/lotto/components/Task/Task";
import {Hmacstr} from "@/views/upload/utils/Sign";
import {appSecret} from "@/views/upload/utils/utils";
import {accessToken} from "@/api/tianyi/tianyi.api";

export default {
  name: "index",
  components: {
    IndexHead,
    IndexTitleImg,
    IndexBottleImg,
    WishAction,
    RightAction,
    Task,
  },

  created() {
    if(this.$store.getters["User/user"].appUser === undefined){
      this.$router.push('/index')
    }
  },
  mounted() {
    this.$store.dispatch("User/getUploadDetails", this.$store.getters["User/user"].appUser.token)
    this.getToken(this.$store.getters["User/user"].appUser.phone)
  },

  methods: {
    getToken(phone) {
      const timestamp = new Date().getTime()
      const appSignature = Hmacstr("appKey=1130131671201" + "&timestamp=" + timestamp, appSecret).toString().toUpperCase();
      const params = {
        appKey: '1130131671201',
        appSignature: appSignature,
        grantType: "189_passport",
        account: phone + "@189.cn",
        timestamp: timestamp,
      }

      accessToken(params).then(resp => {
        if (resp.accessToken) {
          this.$store.commit("User/SET_TOKEN", resp.accessToken)
        }
      })
    },
  }
}
</script>

<style lang="scss">
.page-index {
  width: 100%;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  -webkit-background-size: 100% 100%;
  -o-background-size:100% 100%;
  padding-bottom: 90px;
}
</style>
